import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { InputLabel, FormControl, Select, MenuItem, Box } from "@mui/material";
import {
  fetchAllFarmTypes,
  fetchServiceAgreementDropdown,
  fetchFilteredLandLordShare,
  getCalendarYears,
} from "../../slices/serviceagreements.slice";
import { RootState } from "../../store";
import { ServiceAgreementSpreadsheetComponent } from "./ServiceAgreementSpreadsheetComponent";
import { MultiSelectDropdown } from "../../components/MultiSelect/MultiSelectDropdownComponent";
import CustomButton from "../../components/Button";

const LandlordCostSharingAgreement: React.FC = () => {
  const [selectedCropTypes, setSelectedCropTypes] = useState<any[]>([]);
  const [selectedfarmTypes, setSelectedFarmTypes] = useState<any[]>([]);
  const [previousCropoptions, setPreviousCrops] = useState<any[]>([]);
  const [previousFarmTypes, setPreviousFarmTypes] = useState<any[]>([]);
  const currentYear = new Date().getFullYear();
  const [previousYear, setPreviousYear] = useState(currentYear);
  const dispatch = useAppDispatch();
  const { farmShares, cropType, farmTypes, calendarYears } = useAppSelector(
    (state: RootState) => state.serviceagreements
  );
  const [selectedYear, setSelectedYear] = useState(currentYear);
  useEffect(() => {
    dispatch(fetchAllFarmTypes());
    dispatch(fetchServiceAgreementDropdown("cropType"));
  }, [dispatch]);

  useEffect(() => {
    if (cropType.length > 0 && farmTypes.length > 0) {
      dispatch(getCalendarYears());
      setSelectedCropTypes(cropType);
      setSelectedFarmTypes(farmTypes);

      dispatch(
        fetchFilteredLandLordShare({
          yearId: selectedYear,
          cropTypeIds: cropType.map((x) => x.id),
          landLordIds: farmTypes.map((x: { id: number }) => x.id),
        })
      );
    }
  }, [dispatch, cropType, farmTypes]);

  const handleSearch = () => {
    const CropTypeidsArray = selectedCropTypes.map((value) => value.id);
    const FarmTypeIdsArray = selectedfarmTypes.map((value) => value.id);

    const previousCropoptions = [...selectedCropTypes];
    const previousFarmTypes = [...selectedfarmTypes];
    const previousYear = selectedYear;
    setPreviousYear(previousYear);
    setPreviousCrops(previousCropoptions);
    setPreviousFarmTypes(previousFarmTypes);
    const requestData = {
      cropTypeIds: CropTypeidsArray,
      landLordIds: FarmTypeIdsArray,
      yearId: selectedYear,
    };
    dispatch(fetchFilteredLandLordShare(requestData));
  };

  const handleYearChange = (event: any) => {
    const newYear = parseInt(event.target.value);
    setSelectedYear(newYear);
  };

  return (
    <Box display={"flex"} p={3} gap={2} flexDirection={"column"}>
      <Box display={"flex"} gap={2} alignItems={"center"}>
        <FormControl>
          <InputLabel> Year </InputLabel>
          <Select
            labelId=""
            value={selectedYear}
            label="Year"
            onChange={handleYearChange}
            size="small"
          >
            {calendarYears.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <MultiSelectDropdown
          options={cropType}
          label="Crop"
          selected={selectedCropTypes}
          setSelected={setSelectedCropTypes}
        />
        <MultiSelectDropdown
          options={farmTypes}
          label="Landlord"
          selected={selectedfarmTypes}
          setSelected={setSelectedFarmTypes}
        />
        <CustomButton
          onClick={handleSearch}
          sx={{ width: "110px" }}
          disabled={!selectedCropTypes.length || !selectedfarmTypes.length}
        >
          Search
        </CustomButton>
      </Box>
      <ServiceAgreementSpreadsheetComponent
        data={farmShares}
        cropOptions={previousCropoptions}
        farmOptions={previousFarmTypes}
        selectedYear={selectedYear}
        previousYear={previousYear}
      />
    </Box>
  );
};
export default LandlordCostSharingAgreement;